import * as React from "react";

export type SubscriptionStatus = "active" | "expired" | "none";

const STATUS_LABELS: Record<SubscriptionStatus, string> = {
  active: "Premium",
  expired: "Истекла",
  none: "Free",
};

// Darker text on tinted backgrounds for WCAG 2.2 AA 4.5:1 contrast on small text.
const STATUS_CLASS: Record<SubscriptionStatus, string> = {
  active:
    "text-[var(--accent)] bg-[var(--accent-weak)] before:bg-[var(--accent)]",
  expired:
    "text-[#7a5200] bg-[rgba(196,138,26,0.10)] before:bg-[var(--warn)]",
  none: "text-[#5a5a5a] bg-[rgba(0,0,0,0.05)] before:bg-[#5a5a5a]",
};

interface SubscriptionStatusPillProps {
  status: SubscriptionStatus;
}

export function SubscriptionStatusPill({
  status,
}: SubscriptionStatusPillProps): React.JSX.Element {
  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 text-[12px] font-[500] px-2.5 py-0.5 rounded-full whitespace-nowrap",
        "before:content-[''] before:w-1.5 before:h-1.5 before:rounded-full before:flex-shrink-0",
        STATUS_CLASS[status],
      ].join(" ")}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
